var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurBluePaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0069b1",
    transform: "matrix(1.5 0 0 1.5 -12 -13)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.375,
    cy: 21.625,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.875,
    cy: 17.625,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.875,
    cy: 17.625,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.41,
    cy: 21.625,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.215 26.985c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurBluePaw);
export default __webpack_public_path__ + "static/media/OurBluePaw.cb7c62ba23c2c5e91f5c1887bbac28f0.svg";
export { ForwardRef as ReactComponent };